import { useEffect, useState } from "react";
import {
  useFetcher,
  useLoaderData,
  useNavigate,
} from "react-router-dom";
import { unpackObjForSubmit, packObjForSubmit } from "../../utils";
import { doFetch } from "../../utils/doFetch";
import { IContactEmailData, IContactPhoneNumberData } from "./ContactPhoneNumberData";
import { defaultData, ProgressBarSteps } from "./ContactPhoneNumberModels";
import { doFetchPut } from "../../utils/doFetchPut";
import { ContactPhone } from "./ContactPhone";

export const contactPhoneRouteLoader = async ({
  request,
}: {
  request: any;
  params: any;
}) => {
  return doFetch(
    `my-profile-contact-phone`,
    { signal: request.signal },
    true,
    true
  );
};

export const contactEmailRouteAction = async ({
  request,
}: {
  request: any;
  params: any;
}) => {
  let formData = await request.formData();
  let obj = JSON.parse(unpackObjForSubmit(formData));
  return doFetchPut(
    "my-profile-contact-email",
    { signal: request.signal },
    obj
  );
};

export const contactPhoneRouteAction = async ({
  request,
}: {
  request: any;
  params: any;
}) => {
  let formData = await request.formData();
  let obj = JSON.parse(unpackObjForSubmit(formData));
  return doFetchPut(
    "my-profile-contact-phone",
    { signal: request.signal },
    obj
  );
};

export const ContactPhoneRoute = () => {
  const fetcher = useFetcher();
  const data = useLoaderData() as IContactEmailData;

  const navigate = useNavigate();

  const [currentData, setCurrentData] = useState<IContactEmailData>({
    ...defaultData,
    ...data,
    employeePhones: {
      ...defaultData.employeePhones,
      ...data.employeePhones,
    },
  });

  const [activeStep, setActiveStep] = useState<ProgressBarSteps>(ProgressBarSteps.VerifyEmail);
  const [isNextDisabled, setIsNextDisabled] = useState<boolean>(true);
  const [isFormTouched, setIsFormTouched] = useState(false);
  const [hasVerifiedEmail, setHasVerifiedEmail] = useState(!!data.employeeEmail);
  const [submissionSuccess, setSubmissionSuccess] = useState(false);
  
  const onChange = (field: keyof IContactPhoneNumberData, value: string) => {
    setCurrentData(prev => ({
        ...prev,
        employeePhones: {
          ...prev.employeePhones,
          [field]: value.replace(/\D+/g, "").slice(0, 10),
        },
      }));
      setIsFormTouched(true);
};

  const onSubmit = () => {  
    const phoneFormData = {
      PrimaryPhone: currentData.employeePhones.employeePrimaryPhone,
      PrimaryPhoneExtension: currentData.employeePhones.employeePrimaryPhoneExtension,
      MobilePhone: currentData.employeePhones.employeeMobilePhone,
    };
    fetcher.submit(packObjForSubmit(phoneFormData), { method: "put" });
    const currentIndex = Object.values(ProgressBarSteps).indexOf(activeStep);
    if (currentIndex < Object.values(ProgressBarSteps).length - 1) {
      setActiveStep(Object.values(ProgressBarSteps)[currentIndex + 1]);
    }
  };

  const onSubmitEmail = async () => {
    const email = currentData.employeeEmail.trim();
    const formData = packObjForSubmit({ email }); 
    fetcher.submit(formData, { method: "put", action: "/contact-phone/verify-email" });
  };

  useEffect(() => {
    if (fetcher.data) {
      if (fetcher.data.success) {
        // Success logic here
        setSubmissionSuccess(true);
      } else {
        // Error logic here
        setSubmissionSuccess(false);
        // Optionally handle fetcher.data.errorMessage
      }
    }
  }, [fetcher.data]);

  const isValidEmail = (value: string) => {
    const emailRegex =
      /^[A-Z0-9](?:[A-Z0-9._%+-]{0,62}[A-Z0-9])?@([A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\.)+[A-Z]{2,63}$/i;
    return emailRegex.test(value);
  };

  const onSetEmail = ({
    target: { value },
  }: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setCurrentData(prev => ({
      ...prev,
      employeeEmail: value,
    }));
    setIsFormTouched(true);
  };

  const onNext = () => {
    const currentIndex = Object.values(ProgressBarSteps).indexOf(activeStep);
    if (currentIndex < Object.values(ProgressBarSteps).length - 1) {
      setActiveStep(Object.values(ProgressBarSteps)[currentIndex + 1]);
    }
    setIsFormTouched(false);
  };

  return (
    <ContactPhone
      data={currentData}
      submitting={fetcher.state === "submitting"}
      activeStep={activeStep}
      onChange={onChange}
      email={currentData.employeeEmail}
      phones={currentData.employeePhones}
      onSubmit={onSubmit}
      onNext={onNext}
      isNextDisabled={isNextDisabled}
      isFormTouched={isFormTouched}
      submissionSuccess={submissionSuccess}
      hasVerifiedEmail={hasVerifiedEmail}
      isValidEmail={isValidEmail}
      onSetEmail={onSetEmail}
      onSubmitEmail={onSubmitEmail}
      onClose={() => navigate("/my-profile")}
    />
  );
};
